export default "__VITE_ASSET__4f7c1885__"